export const bg_blue = "bg-blue-600";

export const text_green = "text-green-500";
export const text_red = "text-red-500";
export const text_yellow = "text-yellow-600";
export const text_blue = "text-blue-600";
